import isEqual from '@teetsh/app/src/utils/time/isEqual';
import endOfWeek from 'utils/time/endOfWeek';

import getDaysBetween from 'utils/time/getDaysBetween';
import isBefore from 'utils/time/isBefore';
import max from 'utils/time/max';
import min from 'utils/time/min';
import startOfWeek from 'utils/time/startOfWeek';
import startOfDay from './startOfDay';

export function getCalendarWeeksBetween(
  from: Date,
  to: Date,
  sundayStart: boolean = false,
) {
  if (isBefore(to, from)) {
    return [];
  }
  const allWeeks = getDaysBetween(from, to).reduce((acc, d) => {
    const firstDayOfWeek = startOfDay(max([startOfWeek(d, sundayStart), from]));
    const lastDayOfWeek = startOfDay(min([endOfWeek(d, sundayStart), to]));

    if (acc.find(t => isEqual(t.from, firstDayOfWeek))) {
      return acc;
    }
    return [
      ...acc,
      {
        from: firstDayOfWeek,
        to: lastDayOfWeek,
      },
    ];
  }, [] as { from: Date; to: Date }[]);

  return allWeeks;
}
